import * as React from "react";
import { forwardRef } from "react";
const SvgTelephoneWait = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M18.482 23.035A14.28 14.28 0 0 0 5.041 36.15a14.3 14.3 0 0 0 1.441 7.418l-.377 1.221c6.016 10.673 13.218 20.15 21.596 28.43 8.381 8.278 17.944 15.354 28.69 21.238l1.37-.363a14.28 14.28 0 0 0 10.182-.065 14.28 14.28 0 0 0 9.032-12.504c-6.692-3.266-13.764-7.76-21.157-13.263a14.28 14.28 0 0 0-7.023 9.513c-10.184-8.336-18.137-17.048-25.58-26.8a14.28 14.28 0 0 0 8.533-6.77c-4.597-5.856-9.013-12.994-13.266-21.17M50 35.745a4.256 4.256 0 1 0 0 8.511 4.256 4.256 0 0 0 0-8.512m15 0a4.256 4.256 0 1 0 0 8.511 4.256 4.256 0 0 0 0-8.512m15 0a4.256 4.256 0 1 0 0 8.511 4.256 4.256 0 0 0 0-8.512" />
  </svg>
);
const ForwardRef = forwardRef(SvgTelephoneWait);
export default ForwardRef;
